import React from 'react';
import Layout from '../components/Layout';
import * as styles from '../styles/contact.module.css'
import contactBackImg from '../../static/assets/contacto.png';

function Contact() {
  return (
    <Layout contentStyle="contentForContact" >
      <img className={styles.backImg} src={contactBackImg} alt="Random Offices" />
      <div className={styles.main}>
        {/* <div className={styles.about}>
          <div className={styles.title}>
            <h6>about</h6>
            <div className={styles.stroke}></div>
          </div>
          <span className={styles.abouttext}>lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti ducimus, commodi fugit hic maiores illo, ipsam animi quam nesciunt quas dolor.</span>
        </div> */}
        <div className={styles.phoneandmail}>
          <span>(011) 4054 4025</span>
          <a href="mailto:hola@randomlab.com.ar">hola@randomlab.com.ar</a>
        </div>
        <div className={styles.address}>
          <span>yrigoyen 750</span>
          <span>vicente lopez, caba</span>
        </div>
        <div className={styles.socialmedia1}>
          <a href="http://www.instagram.com/randomlab_/" rel="noreferrer" target="_blank">instagram</a>
          <a href="http://www.facebook.com/randomlabagency" rel="noreferrer" target="_blank">facebook</a>
        </div>
        <div className={styles.socialmedia2}>
          <a href="https://www.youtube.com/channel/UCmjyvjSVumYEPiRywe2dyaQ" rel="noreferrer" target="_blank">youtube</a>
          <a href="https://vimeo.com/user152545583" rel="noreferrer" target="_blank">vimeo</a>
        </div>
      </div>
      <div className={styles.developedBy}>Desarrollado por <a className={styles.northic} target="_blank" rel="noreferrer" href="https://northic.io/">Northic</a></div>
    </Layout >
  );
}

export default Contact;